import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Button, Card} from 'antd';
import {getTillLimits} from './actions';
import ResponsiveTable from "../common/ResponsiveTable";

const tillLimitsColumns = [
  {
    title: 'Limit Id',
    dataIndex: 'limitId',
    key: 'limitId'
  },
  {
    title: 'Limit',
    dataIndex: 'limit',
    key: 'limit'
  }
];

class TillLimitsPage extends Component {
  componentDidMount() {
    this._load();
  }

  _load = (newPagination) => {
    const {pagination} = this.props;
    this.props.getTillLimits({pagination: newPagination || pagination});
  };

  handleSet = e => {
    e.preventDefault();
    this.props.history.push('/till-limit/set');
  };

  render() {
    const {loading, tillLimits, pagination} = this.props;
    return (
      <Card title="Till Limits" extra={<Button type="primary" icon="plus" onClick={this.handleSet}>Set</Button>}>
        <ResponsiveTable
          loading={loading}
          columns={tillLimitsColumns}
          dataSource={tillLimits}
          rowKey={row => `${row.tillLimitId}-${row.limitId}`}
          pagination={pagination}
          onChange={this._load}
        />
      </Card>
    );
  }
}

TillLimitsPage.propTypes = {
  history: PropTypes.object.isRequired,
  getTillLimits: PropTypes.func.isRequired,
  tillLimits: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  pagination: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  tillLimits: state.tillLimit.tillLimits,
  loading: state.tillLimit.tillLimitsLoading,
  pagination: state.tillLimit.tillLimitsPagination,
});

const mapDispatchToProps = dispatch => ({
  getTillLimits: (payload) => (dispatch(getTillLimits(payload)))
});

export default connect(mapStateToProps, mapDispatchToProps)(TillLimitsPage);



// WEBPACK FOOTER //
// ./src/TillLimit/TillLimitsPage.js